import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import LoaderSvg from 'images/v5/icons/loader.svg';
import styles from './Button.module.scss';
function Button({ size = 's', theme = 'fill', color = 'secondary', display = 'inline', shape = 'inline', align = 'center', submit = false, disabled = false, loading = false, active = false, to, href, title, onClick, leftIcon, rightIcon, children = null, testId, }) {
    const handleClick = (e) => {
        if (onClick && !disabled && !loading) {
            onClick(e);
        }
    };
    const classes = classNames(styles.wrap, styles[size], styles[theme], styles[color], styles[display], styles[shape], styles[align], {
        [styles.loading]: loading,
        [styles.isActive]: active,
    });
    const content = (React.createElement(React.Fragment, null,
        leftIcon && leftIcon,
        children && React.createElement("p", null, children),
        rightIcon && React.createElement("span", { className: styles.rightIcon }, rightIcon)));
    if (href) {
        return (React.createElement("a", { type: "button", href: href, className: classes, target: "_blank", rel: "noopener noreferrer", onClick: handleClick, "data-test": testId, title: title }, content));
    }
    if (to) {
        return (React.createElement(Link, { type: "button", role: "link", to: to, className: classes, "aria-current": active ? 'page' : undefined, onClick: handleClick, "data-test": testId, title: title }, content));
    }
    return (React.createElement("button", { type: submit ? 'submit' : 'button', className: classes, disabled: disabled, onClick: handleClick, title: title, "data-test": testId },
        content,
        loading && (React.createElement("span", { className: styles.loaderWrap },
            React.createElement(LoaderSvg, null)))));
}
export default Button;
